function filterValueFormat(value) {
  if (Array.isArray(value)) {
    return value.join(',');
  }
  if (typeof value === 'object' && value.hasOwnProperty('values')) {
    return filterValueFormat(value.values);
  }
  return value;
}

export function filterFormatter(filters) {
  if (Array.isArray(filters)) {
    return filters.map((key) => `${key}:${filterValueFormat(filters[key])}`).join('|');
  }
  if (typeof filters === 'object') {
    return Object.keys(filters).map((key) => `${key}:${filterValueFormat(filters[key])}`).join('|');
  }
  return filters;
}
